class GQLQueryIterator {
  /**
   * @param {function} nextFunc
   */
  constructor(nextFunc) {
    this.nextToken = undefined
    this.hasCompleted = false
    this.iterations = 0
    this.next = nextFunc.bind(this)
  }
}

export default GQLQueryIterator
